"use client";
import React from "react";

// Responsive container (no transform-scaling).
// Keeps content fluid up to `baseWidth` and prevents horizontal scroll.
export default function ScaleContainer({
  baseWidth = 1024,
  // minScale / maxScale kept for API compatibility; unused by responsive layout
  minScale: _minScale = 0.6,
  maxScale: _maxScale = 1,
  children,
}: {
  baseWidth?: number;
  minScale?: number;
  maxScale?: number;
  children: React.ReactNode;
}) {
  return (
    <div className="w-full">
      <div
        // Allow pages to keep using the same component without transform-based scaling
        style={{ maxWidth: baseWidth, width: "100%" }}
        className="mx-auto"
      >
        {children}
      </div>
    </div>
  );
}
